// extracted by mini-css-extract-plugin
export var menuIcon = "_rk-0";
export var menuIconInline = "_rk-1";